export const contactsData = {
    email: 'hameexr@gmail.com',
    phone: '+923444225504',
    address: 'Lahore, Pakistan',
}